<template>
    <my-dialog ref="dialog" title="激活我的邮箱">
        <el-card shadow="hover">
            <div v-if="!isEmailActivated">
                <p class="font-gray">激活邮箱后，总共可获赠 <span class="font-black">{{totalRewardPoints}}</span> 积分</p>
                <p class="font-gray"
                    >（说明：<span>新用户赠 <span style="color:#303133">{{$store.state.newUserRewardPoints}}</span> 积分</span
                    ><span v-if="inviteeRewardPoints===0 && isDisplayInviteCode">，未使用邀请码</span
                    ><span v-else-if="isDisplayInviteCode">，使用邀请码赠 <span style="color:#303133">{{inviteeRewardPoints}}</span> 积分</span>）
                </p>
                <p>{{email}}</p>
                <p>
                    <el-button type="danger" @click="sendActivatedCode()" :disabled="isCountDown"
                        >发送验证码至我的邮箱<span v-show="isCountDown">（{{count}}）</span></el-button>
                </p>
                <p style="width:250px; margin-top:20px">
                    <el-form ref="vform" :model="vform" status-icon :rules="rules" :disabled="vform.disable">
                        <el-form-item prop="activateCode">
                            <div style="display: inline-flex;">
                                <el-input type="activateCode" placeholder="请输入激活码" v-model="vform.activateCode" :maxlength="100" :minlength="1" />
                                <el-button type="danger" :loading="isActiviating" @click="activateEmail()" style="margin-left:6px">激活</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </p>
            </div>
        </el-card>
    </my-dialog>
</template>

<script>
    import MyDialog from "../../commons/MyDialog";
    import {errorMessage, GlobalLoading, loadingInstance, successMessage} from "../../../utils";
    import {sendEmailActivateCode, verifyEmailActivaiteCode, activateEmail} from "../../../data/user";
    import {validateEmailActiviateCode} from "../../../validator";

    export default {
        name: "UserActivateEmail",
        components: { MyDialog },
        data(){
            return {
                isActivated: false, // 表示邮箱已经验证过了
                isActiviating: false, // 邮箱正在验证中... disable the activaite button
                isCountDown: false,
                count: 60,  // 倒计时
                vform: {
                    activateCode: null,
                    disable: false
                },
                rules: {
                    activateCode: [
                        { required: false, validator: validateEmailActiviateCode.bind(this), trigger: ['blur'] }, // 通过 bind 将 this 传入
                    ]
                }
            }
        },
        computed: {
            totalRewardPoints(){
                if (this.$store.state.user !== null){
                    return this.$store.state.newUserRewardPoints + this.$store.state.user.inviteeRewardPoints;
                }else{
                    return '....'
                }
            },
            inviteeRewardPoints(){
                return this.$store.state.user !== null ? this.$store.state.user.inviteeRewardPoints : 0;
            },
            email(){
                return this.$store.state.user !== null ? this.$store.state.user.email: null;
            },
            isEmailActivated(){
                return this.$store.state.user !== null ? this.$store.state.user.is_email_activated : false
            },
            // 网上有人说，invite code 苹果不允许，因此作为敏感内容后端配置展示
            isDisplayInviteCode(){
                return this.$store.state.displayCtrl === null ? false : this.$store.state.displayCtrl.inviteCode;
            }
        },
        methods: {
            show(){
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                }, 300);

            },
            sendActivatedCode(){
                this.isCountDown = true; // 禁用 send activate code button
                let countdown = null;
                this.count -= 1;
                countdown = setInterval(()=>{
                    this.count -= 1;
                    if(this.count <=0 ){
                        window.clearInterval(countdown);
                        this.isCountDown = false;
                        this.count = 60;
                    }
                }, 1000)
                async function exec(){
                    await sendEmailActivateCode();
                    successMessage('验证码已发送至你的邮箱，请查收');
                }
                exec.bind(this)().catch(error => {
                    console.error(error);
                })
            },
            activateEmail(){
                this.$refs.vform.validate(valid => {
                    if (valid) {
                        this.isActiviating = true;
                        this.vform.disable = true;
                        GlobalLoading.start();
                        activateEmail.bind(this)(this.vform.activateCode).then((r)=> {
                            successMessage('邮箱激活成功');
                            setTimeout(()=>{
                                console.log('navigate to user info panel');
                                this.$refs.dialog.hide();
                                this.$parent.$parent.$refs.userInfo.show();
                            }, 500);
                        }).catch((error)=>{
                            console.error(error);
                            errorMessage(error.message);
                        }).finally(()=>{
                            GlobalLoading.stop();
                            this.isActiviating = false;
                            this.vform.disable = false;
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>

    /*
    TODO_ 这里留下了一个悬案，同样的模板，UserInviteCode、UserInfo 都可以将高度缩减到 260px，偏偏 UserActivateEmail 不行
    通过 !important 解决
    */
    /deep/ .dialog-content-panel {
        height: 260px !important;
    }

    /deep/ .el-divider--horizontal{
        height: 0px;
    }

    /deep/ .el-card__body{
        padding: 8px !important;
    }

    /* 设置 form field 输入成功的图标样式 */
    /deep/ .el-icon-circle-check:before{
        display: none;
        color: #67C23A;
        content: "\E720";
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserActivateEmail.vue